import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ENVIRONMENT, APPINSIGHTS_CONNECTION_STRING, APPLICATION_INSIGHTS_CONFIG } from "./config";
import { Environment } from "./types";

/* application insights config snipit and instance */
export const APPLICATION_INSIGHTS = new ApplicationInsights({ config: APPLICATION_INSIGHTS_CONFIG });
if (ENVIRONMENT !== Environment.Testing && APPINSIGHTS_CONNECTION_STRING.length > 0) {
  APPLICATION_INSIGHTS.loadAppInsights();
  APPLICATION_INSIGHTS.addTelemetryInitializer(({ tags }) => {
    if (tags) {
      tags["ai.cloud.role"] = "ddb-excel";
      tags["ai.cloud.roleInstance"] = "ddb-excel";
    }
  });
}
